import { render, staticRenderFns } from "./WalletDetailList.vue?vue&type=template&id=662b2a2a&scoped=true&"
import script from "./WalletDetailList.vue?vue&type=script&lang=js&"
export * from "./WalletDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b2a2a",
  null
  
)

export default component.exports